import {SendMessageCanvas} from '../../../../components/messaging/SendMessageCanvas'
import {LeadByID} from '../../leadTypes'

interface FormSMSProps {
  onBack: () => void
  lead: LeadByID
}

export const FormSMS: React.FC<FormSMSProps> = ({onBack, lead}) => {
  if (!lead) return null;

  return (
    <SendMessageCanvas
        show={true}
        onHide={onBack}
        recipient={{
            name: `${lead.name}`.trim(),
            phone: lead.phone,
            email: lead.email
        }}
        context={{
            type: 'LEAD',
            id: lead.id
        }}
        data={lead} // Pass lead data for variable auto-fill
        defaultChannel='WHATSAPP'
    />
  )
}
